import { KpiTextForTracking, PerformanceType } from '@const/PerformanceType';
import { getCountryCodes } from '@utils/CountryUtils';
import { getBaseTimePeriodForMATAndYTD, getPeriodicityForMATAndYTD } from '@utils/PeriodUtils';
import {
  addAllProductGroupFilter,
  addPgLoadedTagInPlace,
  getGeneralCollectionInsightTags,
  getIsUsingCollectionLiveData,
  getPeriodLabel,
} from '@utils/collectionUtils/CollectionUtils';
import { RetailerOverviewCombinedChartInsight } from './Model';
import { constructRevenueTitle } from '@utils/currencyUtils/CurrencyUtils';

export const getCombinedChartInsightInfoTags = async (insight: RetailerOverviewCombinedChartInsight) => {
  const {
    apiParams: { clientId, period, comparisonPeriod, productType, periodType, appliedFilters, countries, productGroup },
    selectedKPIOption,
    collectionDataType,
    volume,
    retailerClientName,
  } = insight;
  const countryIds: string[] = getCountryCodes(countries);
  const baseTimePeriod = getBaseTimePeriodForMATAndYTD(period, periodType);
  const { periodicity } = getPeriodicityForMATAndYTD(baseTimePeriod, periodType);
  const periodLabel = await getPeriodLabel({
    clientId,
    periodicity,
    baseTimePeriod,
    comparisonPeriod,
    countryIds: countryIds,
    productType,
    collectionDataType: getIsUsingCollectionLiveData(period, collectionDataType) ? 'live' : collectionDataType,
    productGroups: productGroup,
  });

  const finalAppliedFilters = addAllProductGroupFilter(appliedFilters);

  const generalCollectionInsightTags = getGeneralCollectionInsightTags({
    periodType: periodicity,
    comparisonPeriod:
      typeof comparisonPeriod === 'object' && comparisonPeriod !== null
        ? JSON.stringify(comparisonPeriod)
        : String(comparisonPeriod),
    selectedGrowthType: '',
    appliedFilters: finalAppliedFilters,
    period: periodLabel,
    retailerClientName: retailerClientName,
  });

  await addPgLoadedTagInPlace(generalCollectionInsightTags, insight.apiParams, collectionDataType);

  const kpiValue =
    (selectedKPIOption as PerformanceType) === PerformanceType.Volume
      ? KpiTextForTracking(volume)[selectedKPIOption as PerformanceType]
      : constructRevenueTitle(insight.factRevenue);

  const otherTags: { key: string; value: string }[] = [
    {
      key: 'KPI',
      value: kpiValue,
    },
  ];

  return [...generalCollectionInsightTags, ...otherTags];
};
